import { Popover as PopoverPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const Popover = (props: ComponentProps<typeof PopoverPrimitive.Root>) => (
  <PopoverPrimitive.Root data-slot="popover" {...props} />
);
